import * as v from "valibot";
import { pageRequest, pageResponse } from "../paging.dto";

export const adminPopularArticleDto = v.object({
  authorAlias: v.string(),
  articleId: v.string(),
  /** Empty when the article row is gone. */
  title: v.string(),
  path: v.string(),
  /** The rolling 90-day score: views * 1 + reads * 5. */
  score: v.number(),
});
export type AdminPopularArticle = v.InferOutput<typeof adminPopularArticleDto>;

export const adminPopularRequest = pageRequest;

export const adminPopularResponse = {
  articles: v.array(adminPopularArticleDto),
  ...pageResponse,
};
